import { TextLogoPreview } from "./text-logo-preview.component";
import { PrimaryButton } from "../../../../components/Buttons/PrimaryButton";
import { SecondaryButton } from "../../../../components/Buttons/SecondaryButton";
import {
  Color,
  Font,
  LogoOptions,
  TransferMethod,
} from "../../../../../core/models/entities/LogoOptions";
import { FontAndColorEditor } from "./font-and-color-editor.component";
import { TransferMethodEditor } from "./transfer-method-editor.component";
import { getConvertedLogoOptions } from "../../../design-editor/design-editor-tool/DesignEditorTool.component";
import LoadingElement from "../../../../components/loading-element/loading-element";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { excludeNonSelectableMethods } from "../../../../../utils/functions/TransferMethodUtil";

export interface NamePlaceholderLogoCreate_VM {
  font: Font | undefined;
  color: Color | undefined;
  onColorChange: (
    value:
      | ((prevState: Color | undefined) => Color | undefined)
      | Color
      | undefined
  ) => void;
  onFontChange: (
    value:
      | ((prevState: Font | undefined) => Font | undefined)
      | Font
      | undefined
  ) => void;
  options: LogoOptions;
  heightMM: number;
  onHeightMMChange: (value: ((prevState: number) => number) | number) => void;
  onAddLogo: () => void;
  onCancel: () => void;
  canAdd: boolean;
  getPreview?: (
    value: string,
    color: Color,
    heightMM: number,
    font: Font,
    transferMethod?: TransferMethod
  ) => Promise<string>;
  isLoading: boolean;
  omitActions?: boolean;
  transferMethod?: TransferMethod;
  setTransferMethod: (
    value:
      | ((prevState: TransferMethod | undefined) => TransferMethod | undefined)
      | TransferMethod
      | undefined
  ) => void;
}

export function NamePlaceholderLogoCreate({
  onAddLogo,
  onCancel,
  onHeightMMChange,
  heightMM,
  onColorChange,
  options,
  color,
  onFontChange,
  font,
  canAdd,
  getPreview,
  isLoading,
  omitActions,
  transferMethod,
  setTransferMethod,
}: NamePlaceholderLogoCreate_VM) {
  return (
    <div className={"flex flex-col h-full space-y-4 py-4"}>
      {isLoading && <LoadingElement transparent />}
      {!!getPreview && (
        <TextLogoPreview
          value={"NAME"}
          font={font}
          color={color}
          heightMM={heightMM}
          isValid={canAdd}
          getPreview={getPreview}
          fieldsPosition="below"
        />
      )}
      <div className={"flex-1"}>
        <FontAndColorEditor
          color={color}
          onSelectColor={onColorChange}
          font={font}
          onSelectFont={onFontChange}
          options={getConvertedLogoOptions(options, "name")}
          fontSize={heightMM}
          showValueField={false}
          onSelectFontSize={onHeightMMChange}
        />
        <TransferMethodEditor
          className="my-4"
          value={transferMethod}
          onChange={setTransferMethod}
          transferMethods={excludeNonSelectableMethods(
            options.transferMethodsNames,
            transferMethod?.key,
            options.blockedMethodKeys
          )}
        />
      </div>
      {omitActions !== true && (
        <>
          <PrimaryButton
            width={"full"}
            className="flex items-center gap-x-2 px-4"
            onClick={onAddLogo}
            disabled={!canAdd}
          >
            <FontAwesomeIcon icon={faPlus} />
            Create Name
          </PrimaryButton>

          <SecondaryButton width={"full"} onClick={onCancel}>
            Cancel
          </SecondaryButton>
        </>
      )}
    </div>
  );
}
